import CryptoJS from 'crypto-js';

export const isEmpty = (value) => {
    return (value == null || (typeof value === "string" && value.trim().length === 0));
};

export const generateRandomAcronym = () => {
    const names = ["Dany", "Ismael", "Lucas", "Hanthony", "Vinicius"];

    let acronym = '';
    const usedIndices = new Set();

    while (usedIndices.size < names.length) {
        const randomIndex = Math.floor(Math.random() * names.length);

        if (!usedIndices.has(randomIndex)) {
            acronym += names[randomIndex].charAt(0).toUpperCase();
            // acronym += names[randomIndex].charAt(1).toUpperCase();
            usedIndices.add(randomIndex);
        }
    }

    return acronym;
};

export const getDatetimeNow = () => {
    const dataAtual = new Date();

    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0'); // Mês começa do 0, então somamos 1
    const ano = dataAtual.getFullYear();

    const hora = String(dataAtual.getHours()).padStart(2, '0');
    const minuto = String(dataAtual.getMinutes()).padStart(2, '0');
    const segundo = String(dataAtual.getSeconds()).padStart(2, '0');

    return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
};

export const emailMask = (value) => {
    value = value.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(value)) {
        return value;
    }

    return value;
};

export const phoneMask = (value) => {
    value = value.trim();

    const phoneRegex = /^\d{9,11}$/;
    const numericValue = value.replace(/\D/g, '');

    if (phoneRegex.test(numericValue)) {
        if (numericValue.length === 9) {
            return numericValue.replace(/(\d{5})(\d{4})/, '$1-$2');
        } else if (numericValue.length === 10) {
            return numericValue.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        } else if (numericValue.length === 11) {
            return numericValue.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }
    }

    return value;
};

export const isValidEmail = (value) => {
    value = value.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(value)) {
        return true; // Validação de e-mail
    }

    return false;
};

export const isValidPhone = (value) => {
    value = value.trim();

    const phoneRegex = /^\d{9,11}$/;
    const numericValue = value.replace(/\D/g, '');

    if (phoneRegex.test(numericValue)) {
        return true; // Validação de telefone
    }

    return false;
};

export const isValidPasswd = (value) => {
    value = value.trim();

    const passwdRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,20}$/;

    if (passwdRegex.test(value)) {
        return true; // Validação de password
    }

    return false;
};

export const truncateText = (texto, limite = 10) => {
    return texto.length > limite ? texto.slice(0, limite) + "..." : texto;
}

export const generateSession_Hash_255 = () => {
    const randomString = CryptoJS.lib.WordArray.random(32).toString();
    const crypto = CryptoJS.SHA256(randomString).toString(CryptoJS.enc.Hex);

    return crypto.slice(0, 63);
};

export const generateSession_Hash_128 = () => {
    const randomString = CryptoJS.lib.WordArray.random(32).toString();
    const crypto = CryptoJS.SHA256(randomString).toString(CryptoJS.enc.Hex);

    return crypto.slice(0, 32);
};

export const uuid8 = () => {
    let random = Math.random();
    let genarete = Math.floor(random * 100000000);
    // Certifica-se de que o número gerado tenha 8 dígitos preenchendo com zeros à esquerda, se necessário
    // genarete = genarete.toString().padStart(8, '0');
    return genarete.toString();
};

export const removeHtmlTags = (text) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;
    return tempDiv.textContent || tempDiv.innerText || "";
};

export const getWidthComponent = (elementId) => {
    const element = document.getElementById(elementId);

    if (!element) {
        return 0;
    }

    return element.offsetWidth;
};

export const isArrayEmpty = (arr) => {
    if (arr === null) {
        return true;
    }

    if (Array.isArray(arr) && arr.length === 0) {
        return true;
    }

    return false;
}

export const handleWindowMatchMedia = () => {
    return window.matchMedia("(max-width: 960px)").matches;
};

export const bytesToBase64 = (byteArray) => {
    let binaryString = '';

    for (let i = 0; i < byteArray.length; i++) {
        binaryString += String.fromCharCode(byteArray[i]);
    }

    return btoa(binaryString); // Codificar para Base64
};

export const base64ToBytes = (base64String) => {
    const binaryString = atob(base64String); // Decodificar Base64
    const byteArray = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
    }

    return byteArray;
};

export const bufferToBase64 = (buffer) => {
    // Converter o array de bytes para uma string (em formato binário)
    const byteArray = new Uint8Array(buffer.data);

    // Convertendo o array de bytes para string binária
    let binaryString = '';
    byteArray.forEach(byte => {
        binaryString += String.fromCharCode(byte);
    });

    // Codificando em base64
    const base64String = btoa(binaryString);

    // Adicionar o prefixo correto para imagens PNG
    return base64String;
};

export const checkBase64Type = (base64String) => {
    // Remover o prefixo de dados URL (se existir)
    const base64Data = base64String.replace(/^data:[a-zA-Z0-9]+\/[a-zA-Z0-9]+;base64,/, '');

    // Converter base64 para bytes
    const byteCharacters = atob(base64Data);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
    }

    // Verificar cabeçalho para MP4, PNG ou PDF
    const fileSignature = byteArray.slice(0, 4);  // Verifique os primeiros 4 bytes

    // MP4: "00 00 00 18" (mp4)
    const isMP4 = fileSignature[0] === 0x00 && fileSignature[1] === 0x00 && fileSignature[2] === 0x00 && fileSignature[3] === 0x18;

    // PNG: "89 50 4E 47" (png)
    const isPNG = fileSignature[0] === 0x89 && fileSignature[1] === 0x50 && fileSignature[2] === 0x4E && fileSignature[3] === 0x47;

    // PDF: "%PDF" (pdf)
    const isPDF = fileSignature[0] === 0x25 && fileSignature[1] === 0x50 && fileSignature[2] === 0x44 && fileSignature[3] === 0x46;

    if (isMP4) {
        return 'MP4';
    } else if (isPNG) {
        return 'PNG';
    } else if (isPDF) {
        return 'PDF';
    } else {
        return 'Desconhecido';
    }
};

export const checkBufferType = (buffer) => {
    // Verificar cabeçalho para MP4, PNG ou PDF
    const fileSignature = buffer.data.slice(0, 4);  // Obter os primeiros 4 bytes

    // PNG: "89 50 4E 47" (png)
    const isPNG = fileSignature[0] === 0x89 && fileSignature[1] === 0x50 && fileSignature[2] === 0x4E && fileSignature[3] === 0x47;

    // MP4: "00 00 00 18" (mp4)
    const isMP4 = fileSignature[0] === 0x00 && fileSignature[1] === 0x00 && fileSignature[2] === 0x00 && fileSignature[3] === 0x18;

    // PDF: "%PDF" (pdf)
    const isPDF = fileSignature[0] === 0x25 && fileSignature[1] === 0x50 && fileSignature[2] === 0x44 && fileSignature[3] === 0x46;

    // JPG/JPEG: "FF D8" (jpg/jpeg)
    const isJPGJPEG = buffer[0] === 0xFF && buffer[1] === 0xD8; // Os primeiros 2 bytes de um JPG/JPEG são FF D8
    const endsWithJPGJPEG = buffer[buffer.length - 2] === 0xFF && buffer[buffer.length - 1] === 0xD9;

    // AVI: "52 49 46 46" (avi)
    const isAVI = fileSignature[0] === 0x52 && fileSignature[1] === 0x49 && fileSignature[2] === 0x46 && fileSignature[3] === 0x46;

    // MKV: "1A 45 DF A3" (mkv)
    const isMKV = fileSignature[0] === 0x1A && fileSignature[1] === 0x45 && fileSignature[2] === 0xDF && fileSignature[3] === 0xA3;

    // GIF: "47 49 46 38" (gif)
    const isGIF = fileSignature[0] === 0x47 && fileSignature[1] === 0x49 && fileSignature[2] === 0x46 && fileSignature[3] === 0x38;

    if (isMP4) {
        return 'MP4';
    } else if (isPNG) {
        return 'PNG';
    } else if (isPDF) {
        return 'PDF';
    } else if (isJPGJPEG && endsWithJPGJPEG) {
        return 'JPG/JPEG';
    } else if (isAVI) {
        return 'AVI';
    } else if (isMKV) {
        return 'MKV';
    } else if (isGIF) {
        return 'GIF';
    } else {
        return 'Desconhecido';
    }
};